import { Form, Select } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";
import { Styles } from "./styled";
interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
  className?: string;
}

type TOption = {
  text: string;
  value: number | string;
};

const defaultOptionDropdown: TOption = {
  text: "----",
  value: "----",
};

const Dropdown = (props: IProps) => {
  const {
    item,
    isDisable,
    nameItem,
    style,
    preview,
    isTable,
    styleColor = {},
    className,
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisable;

  return (
    <Styles
      style={style}
      background={styleColor?.background}
      color={styleColor?.color}
    >
      <div className="value_text_container">{isShowOnlyValue && value}</div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={[
          {
            required: item.is_required_field,
            message: `必須項目です`,
          },
        ]}
        className={className}
      >
        <Select
          defaultValue={item?.default_value || defaultOptionDropdown.value}
        >
          {[
            defaultOptionDropdown,
            ...(item.item_config_data?.options || []),
          ].map((option: TOption, i: number) => {
            return (
              <Select.Option
                key={i}
                value={option.text}
                className="custom-option"
              >
                {option.text}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </Styles>
  );
};
export default Dropdown;
